import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  NativeSelect,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Button,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
// import ImageUpload from "../ImageUpload/ImageUpload";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import ImagePreviewDialog from "../../Components/ImagePreviewDialog/ImagePreviewDialog";
import DesktopView from "../../Components/views/DesktopView";
import MobileView from "../../Components/views/MobileView";
import CheckAndReturn from "../../utility/CheckAndReturn";
import StudentDocumentDialog from "./StudentDocumentDialog";
import WebcamDialog from "./WebcamDialog";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import TableViewIcon from "@mui/icons-material/TableView"; // Excel Icon
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { exportToPdf } from "./exportToPdf";
import { exportToExcel } from "./exportToExcel";
//FUNCTION
const RegistrationTable = ({
  handleEdit,
  handleImage,
  handleBiometric,
  handleIris,
  isChanged,
  examId,
}) => {
  //#region code
  const { user_id, company_id,companyName, is_super, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const rowsPerPageOptions = [100, 200, 500];
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);

  const [customerList, setCustomerList] = useState([]);
  const [examList, setExamList] = useState([]);
  const [exam_id, setExam_id] = useState(null);
  const [searchBy, setSearchBy] = useState("full_name");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cannotAdd, setCannotAdd] = useState(true);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [cannotUpdate, setCannotUpdate] = useState(true);
  const [findUnVerified, setFindUnVerified] = useState(true);
  const [isFirstStage, setIsFirstSatge] = useState(false);
  const [verificationType, setVerificationType] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [sortField, setSortField] = useState('registration_no');
  const [sortOrder, setSortOrder] = useState("desc");
  const handleSort = (field) => {
    if (field === "action" || field === "image" || field === "status") return; // ignore action column
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };


  // Aapke component ke andar:
  const [anchorEl, setAnchorEl] = useState(null);
  const openExportMenu = Boolean(anchorEl);

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };

  const handleExportExcel = () => {
  handleExportClose();

  if (!customerList || customerList.length === 0) {
    alert("No data available to export");
    return;
  }

  // Excel Export call
  exportToExcel(customerList, companyName);
};

  const handleExportPdf = () => {
  handleExportClose();

  if (!customerList || customerList.length === 0) {
    alert("No data available to export");
    return;
  }

  // Call the separate PDF export utility
  exportToPdf(customerList, companyName);
};

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const canEdit = CheckAndReturn.PermissionHandler(
    "edit-registration",
    permissions
  );

  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1); // toggle/increment
  };
  const checkPermissions = () => {
    try {
      const isAdd = CheckAndReturn.PermissionHandler(
        "create-student",
        permissions
      );
      setCannotAdd(!isAdd);
      const isUpdate = CheckAndReturn.PermissionHandler(
        "update-student",
        permissions
      );
      setCannotUpdate(!isUpdate);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchExams = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
      };
      const response = await configServ.getUpcomingExamList(dataToSend);
      if (response.status === 200) {
        setExamList(response.data);
      }
    } catch (error) {
      console.error("Error fetching exams:", error);
    }
  };

  useEffect(() => {
    checkPermissions();
    fetchExams();
  }, []);

  useEffect(() => {
    if (exam_id !== null || isEnrolled === false) {
      fetchCustomerList();
    }
  }, [
    isChanged,
    page,
    rowsPerPage,
    search,
    exam_id,
    findUnVerified,
    isEnrolled,
    refreshKey,
    sortField,
    sortOrder
  ]);

  const fetchCustomerList = async () => {
    try {
      const dataToSend = {
        user_id: user_id,
        is_super: is_super,
        company_id: company_id,
        exam_id: exam_id,
        unverified: findUnVerified,
        search_by: searchBy,
        search: search,
        per_page: rowsPerPage,
        page: page + 1,
        sort_field: sortField, // 👈 add this
        sort_order: sortOrder, // 👈 add this
      };
      setLoading(true);
      const result =
        isEnrolled === true
          ? await configServ.getStudent(dataToSend)
          : await configServ.getStudentsByCompany(dataToSend);
      if (result.status === 200) {
        setCustomerList(result.data);
        setCount(result.meta.total);
      } else {
        setCount(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleExam = (params) => {
    try {
      const data = parseInt(params.target.value);
      if (data > 0) {
        setExam_id(data);

        const selectedExam = examList.find((x) => x.id === data);
        setIsFirstSatge(selectedExam.isFirstStage === 0 ? false : true);
        setVerificationType(selectedExam.verification_type);

        examId(data);
      } else {
        setExam_id(null);
        setIsFirstSatge(false);
        setVerificationType(0);
        examId(null);
      }
      setPage(0);
      setSearch("");
    } catch (e) {
      console.log(e);
    }
  };

  const handleVerifiy = (params) => {
    try {
      const data = params.target.value;

      if (data === "true") {
        setFindUnVerified(true);
      } else {
        setFindUnVerified(false);
      }
      setPage(0);
      setSearch("");
    } catch (error) {
      console.log("error", error);
    }
  };

  const headers = [
    { label: "Registration ID", value: "registration_no" },
    { label: "Full Name", value: "full_name" },
    { label: "Father's Name", value: "father_name" },
    { label: "Mobile No", value: "mobile_no" },
    { label: "Status", value: "status" },
    { label: "Image", value: "image" },
    { label: "Action", value: "action" },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, page * rowsPerPage);

  const headerCellStyle = {
    fontSize: 14, // Adjust the font size as needed
    fontWeight: "bold",
    backgroundColor: "black",
    color: "white",
    padding: 5,
    textAlign: "center",
  };

  const evenRowStyle = {
    background: "#f5f5f5",
  };

  const oddRowStyle = {
    background: "white",
  };

  const rowStyle = {
    "&:hover": {
      background: "#f1f9fe",
    },
  };

  const cellStyle = {
    py: 0,
    my: 0,
    textAlign: "center",
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = (event) => {
    try {
      const data = event.target.value;
      if (data === "") {
        setSearch(null);
      } else {
        setSearch(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEnroll = () => {
    try {
      setIsEnrolled(!isEnrolled);
      setExam_id(null);
    } catch (e) {
      console.log(e);
    }
  };
  const [selectedRow, setSelectedRow] = useState(null);
  const handleWebCamera = (row) => {
    setSelectedRow(row); // 👈 save row data
    setOpenDialog(true); // 👈 dialog open
  };

  const [docDialogOpen, setDocDialogOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleCreateFolder = (row) => {
    setSelectedStudent(row);
    setDocDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDocDialogOpen(false);
    setSelectedStudent(null);
  };

  //#endregion

  return (
    <>
      <ImagePreviewDialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        imageBase64={selectedImage}
        title="Student Photo Preview"
      />

      {selectedStudent && (
        <StudentDocumentDialog
          open={docDialogOpen}
          handleClose={handleCloseDialog}
          studentId={selectedStudent.id}
          studentName={selectedStudent.first_name} // Optional (Display ke liye)
        />
      )}

      <WebcamDialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setSelectedRow(null);
        }}
        rowData={selectedRow}
        isChanged={handleRefresh}
      />
      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-start"
        style={{ paddingBottom: 10, paddingTop: 0 }}
        spacing={2}
        direction={"row"}
      >
        <Grid item xs={12} md={4} justifyContent={"flex-start"}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Candidate List: {count}
          </Typography>
        </Grid>

        <Grid item xs={12} md={2.5}>
          <FormControl fullWidth>
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Search By
            </InputLabel>
            <NativeSelect
              defaultValue={"full_name"}
              onChange={handleSearchBy}
              inputProps={{
                name: "searchBy",
                id: "uncontrolled-native",
              }}
            >
              <option value={"full_name"}>Student Name</option>
              <option value={"registration_no"}>Registration No</option>
            </NativeSelect>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={3.5}>
          <TextField
            id="outlined-basic"
            size="small"
            fullWidth
            placeholder="Search..."
            variant="outlined"
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fill: "grey" }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Export Dropdown Button */}
        <Grid item xs={12} md={2} display="flex" justifyContent="flex-end">
          <Button
            fullWidth
            variant="contained"
            color="primary"
            startIcon={<FileDownloadIcon />}
            onClick={handleExportClick}
            sx={{ height: "40px", textTransform: "none" }}
          >
            Export
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={openExportMenu}
            onClose={handleExportClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleExportExcel}>
              <ListItemIcon>
                <TableViewIcon fontSize="small" color="success" />
              </ListItemIcon>
              <ListItemText>Export to Excel</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleExportPdf}>
              <ListItemIcon>
                <PictureAsPdfIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Export to PDF</ListItemText>
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>

      <MobileView>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "2px", marginBottom: "2px" }}
        >
          {/* 🔹 Sort Field */}
          <Grid item xs={12} sm={4} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Sort Field</InputLabel>
              <Select
                value={sortField || ""}
                onChange={(e) => setSortField(e.target.value)}
                label="Sort Field"
              >
                <MenuItem value="">-- Select Field --</MenuItem>
                <MenuItem value="full_name">Name</MenuItem>
                <MenuItem value="father_name">Father's Name</MenuItem>
                <MenuItem value="registration_no">Registration No</MenuItem>
                <MenuItem value="mobile_no">Mobile No</MenuItem>


              </Select>
            </FormControl>
          </Grid>

          {/* 🔹 Sort Order */}
          <Grid item xs={12} sm={4} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Order</InputLabel>
              <Select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                label="Order"
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MobileView>

      <MobileView>
        <Box sx={{ position: "relative", pb: "80px" }}>
          {loading ? (
            <CircularProgress />
          ) : customerList.length > 0 ? (
            <>
              {customerList.map((row, rowIndex) => (
                <Card key={rowIndex} sx={{ mb: 2, p: 2 }}>
                  <Box display="flex" alignItems="center">
                    {row.thumbnail_base64 ? (
                      <Avatar
                        src={row.thumbnail_base64}
                        alt="Student Image"
                        sx={{ width: 50, height: 50, mr: 2 }}
                        onClick={() => {
                          setSelectedImage(row.thumbnail_base64);
                          setPreviewOpen(true);
                        }}
                      />
                    ) : (
                      <Avatar sx={{ width: 50, height: 50, mr: 2 }}>❌</Avatar>
                    )}

                    <Box flex={1}>
                      <Typography variant="subtitle1">
                        {page * rowsPerPage + rowIndex + 1}. {row.full_name}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Reg No: {row.registration_no}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Mobile No: {row.mobile_no}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Father's Name: {row.father_name}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        Status: {row.status ? "✅" : "❌"}
                      </Typography>
                    </Box>

                    <Box>
                      <IconButton
                        onClick={
                          CheckAndReturn.PermissionHandler(
                            "edit-registration",
                            permissions
                          )
                            ? () => handleEdit(row)
                            : () => { }
                        }
                      >
                        <EditIcon color="primary" />
                      </IconButton>

                      <IconButton onClick={() => handleWebCamera(row)}>
                        <CameraAltIcon color="primary" />
                      </IconButton>

                      <IconButton onClick={() => handleCreateFolder(row)}>
                        <CreateNewFolderIcon color="primary" />
                      </IconButton>
                    </Box>
                  </Box>
                </Card>
              ))}

              {/* 🔥 Fixed Bottom Pagination */}
              <Box
                sx={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  bgcolor: "white",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                  zIndex: 999,
                }}
              >
                <TablePagination
                  rowsPerPageOptions={rowsPerPageOptions}
                  component="div"
                  count={count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </>
          ) : (
            <Typography sx={{ textAlign: "center", color: "red", mt: 2 }}>
              No Candidates Found.
            </Typography>
          )}
        </Box>
      </MobileView>

      <DesktopView>
        <TableContainer component={Paper} elevation={0}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                {headers.map((header, index) => {
                  const isActive = sortField === header.value;
                  return (
                    <TableCell
                      key={index}
                      style={headerCellStyle}
                      onClick={() => handleSort(header.value)}
                      sx={{
                        cursor: !["image", "status", "action"].includes(
                          header.value
                        )
                          ? "pointer"
                          : "default",
                      }}
                    >
                      {header.label}
                      {!["image", "status", "action"].includes(
                        header.value
                      ) && (
                          <span style={{ marginLeft: 4 }}>
                            {isActive ? (sortOrder === "asc" ? "▲" : "▼") : "⇅"}
                          </span>
                        )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            {loading === false && (
              <TableBody>
                {exam_id === null && isEnrolled === true ? (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      sx={{ textAlign: "center", color: "red" }}
                    >
                      <div>
                        <p>
                          <b>Please select an examination.</b>
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : customerList.length > 0 ? (
                  customerList.map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        ...rowStyle,
                        ...(rowIndex % 2 === 0 ? evenRowStyle : oddRowStyle),
                      }}
                    >
                      <TableCell sx={cellStyle}>
                        {page * rowsPerPage + rowIndex + 1}
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {row.registration_no}
                      </TableCell>

                      <TableCell sx={cellStyle}>{row.full_name} </TableCell>
                      <TableCell sx={cellStyle}>{row.father_name}</TableCell>
                      <TableCell sx={cellStyle}>{row.mobile_no}</TableCell>
                      <TableCell sx={cellStyle}>
                        {row.status ? "✅" : "❌"}
                      </TableCell>

                      <TableCell sx={cellStyle}>
                        {row.thumbnail_base64 ? (
                          <Avatar
                            src={row.thumbnail_base64}
                            alt="Student Image"
                            sx={{ width: 40, height: 40, cursor: "pointer" }}
                            onClick={() => {
                              setSelectedImage(row.thumbnail_base64);
                              setPreviewOpen(true);
                            }}
                          />
                        ) : (
                          <span style={{ color: "red", fontSize: "20px" }}>
                            ❌
                          </span>
                        )}
                      </TableCell>

                      <TableCell sx={cellStyle}>
                        <IconButton
                          title="Edit"
                          onClick={
                            canEdit
                              ? () => {
                                handleEdit(row);
                                scrollToTop();
                              }
                              : undefined
                          }
                          disabled={!canEdit}
                        >
                          <EditIcon color={canEdit ? "primary" : "disabled"} />
                        </IconButton>
                        <IconButton
                          title="Create Folder"
                          onClick={() => handleCreateFolder(row)}
                        >
                          <CreateNewFolderIcon color="primary" />
                        </IconButton>

                        <IconButton
                          title="Camera"
                          onClick={() => handleWebCamera(row)}
                        >
                          <CameraAltIcon color="primary" />
                        </IconButton>

                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      sx={{ textAlign: "center", color: "red" }}
                    >
                      <div>
                        <p>
                          <b>No Candidates Found.</b>
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                {/* {emptyRows > 0 && (
              <TableRow style={{ height: 1 * emptyRows }}>
                <TableCell colSpan={headers.length + 2} />
              </TableRow>
            )} */}
              </TableBody>
            )}
            {loading === true && (
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{ textAlign: "center", color: "red" }}
                >
                  <div>
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </Table>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </DesktopView>
    </>
  );
  // }
};

export default RegistrationTable;
